import fourKSVG from './img/4k.svg';
import addFolderSVG from './img/add-folder.svg';
import addTodoListSVG from './img/add-to-list.svg';
import addUserSVG from './img/add-user.svg';
import alignBottomSVG from './img/align-bottom.svg';
import alignHCenterSVG from './img/align-h-center.svg';
import alignLeftSVG from './img/align-left.svg';
import alignRightSVG from './img/align-right.svg';
import alignTextCenterSVG from './img/align-text-center.svg';
import alignTextLeftSVG from './img/align-text-left.svg';
import alignTextRightSVG from './img/align-text-right.svg';
import alignTopSVG from './img/align-top.svg';
import alignVCenterSVG from './img/align-v-center.svg';
import appStoreSVG from './img/app-store.svg';
import appSVG from './img/app.svg';
import arrowDownSVG from './img/arrow-down.svg';
import arrowLeftSVG from './img/arrow-left.svg';
import arrowRightSVG from './img/arrow-right.svg';
import arrowUpSVG from './img/arrow-up.svg';
import audioSVG from './img/audio.svg';
import audioOffSVG from './img/audio-off.svg';
import audioOnSVG from './img/audio-on.svg';
import basicSiteSVG from './img/basic-site.svg';
import bulbOffSVG from './img/bulb-off.svg';
import bulbSVG from './img/bulb.svg';
import calendarSVG from './img/calendar.svg';
import cameraSVG from './img/camera.svg';
import canvasBrushSVG from './img/canvas-brush.svg';
import caretDownSVG from './img/caret-down.svg';
import caretUpSVG from './img/caret-up.svg';
import castingSVG from './img/casting.svg';
import channelSVG from './img/channel.svg';
import checkboxCheckedSVG from './img/checkbox-checked.svg';
import checkboxDeselectSVG from './img/checkbox-deselect.svg';
import checkboxEmptySVG from './img/checkbox-empty.svg';
import checkedCircleSVG from './img/checked-circle.svg';
import circleArrowLeftSVG from './img/circle-arrow-left.svg';
import circleArrowRightSVG from './img/circle-arrow-right.svg';
import circleSVG from './img/circle.svg';
import clearCacheSVG from './img/clear-cache.svg';
import clipboardSVG from './img/clipboard.svg';
import clockSVG from './img/clock.svg';
import closeSVG from './img/close.svg';
import createPlaylistSVG from './img/create-playlist.svg';
import dashboardSVG from './img/dashboard.svg';
import disableViewSVG from './img/disable-view.svg';
import documentSVG from './img/document.svg';
import dotSVG from './img/dot.svg';
import downloadSVG from './img/download.svg';
import dragSVG from './img/drag.svg';
import duplicateSVG from './img/duplicate.svg';
import editCircleSVG from './img/edit-circle.svg';
import editSVG from './img/edit.svg';
import emailAddSVG from './img/email-add.svg';
import emailCancelSVG from './img/email-cancel.svg';
import emailResendSVG from './img/email-resend.svg';
import emailSVG from './img/email.svg';
import enterFullScreenSVG from './img/enter-fullscreen.svg';
import exitFullScreenSVG from './img/exit-fullscreen.svg';
import expandSVG from './img/expand.svg';
import eternalSVG from './img/external.svg';
import globeSVG from './img/globe.svg';
import gridSVG from './img/grid.svg';
import groupsRemoveDefaultSVG from './img/groups-remove-default.svg';
import groupsSVG from './img/groups.svg';
import helpSVG from './img/help.svg';
import homeSVG from './img/home.svg';
import imageSVG from './img/image.svg';
import infoSVG from './img/info.svg';
import layerBackSVG from './img/layer-back.svg';
import layerForwardSVG from './img/layer-forward.svg';
import layerToBackSVG from './img/layer-to-back.svg';
import layerToFrontSVG from './img/layer-to-front.svg';
import linkSVG from './img/link.svg';
import listSVG from './img/list.svg';
import locationSVG from './img/location.svg';
import lockSVG from './img/lock.svg';
import logoutSVG from './img/logout.svg';
import magicSVG from './img/magic.svg';
import mediaFolderShareSVG from './img/media-folder-shared.svg';
import mediaFolderSVG from './img/media-folder.svg';
import mediaMoveSVG from './img/media-move.svg';
import mediaSelectSVG from './img/media-select.svg';
import mediaSVG from './img/media.svg';
import minusFillSVG from './img/minus-fill.svg';
import minusSVG from './img/minus.svg';
import moveSVG from './img/move.svg';
import ownerAddSVG from './img/owner-add.svg';
import ownerRemoveSVG from './img/owner-remove.svg';
import ownerswitchSVG from './img/owner-switch.svg';
import pauseSVG from './img/pause.svg';
import playFullScreenSVG from './img/play-fullscreen.svg';
import playSVG from './img/play.svg';
import playingScreenSVG from './img/playing-screen.svg';
import playlistSVG from './img/playlist.svg';
import plusfillSVG from './img/plus-fill.svg';
import plusSVG from './img/plus.svg';
import previewSVG from './img/preview.svg';
import redoSVG from './img/redo.svg';
import refreshSVG from './img/refresh.svg';
import removeFillSVG from './img/remove-fill.svg';
import rocketSVG from './img/rocket.svg';
import scheduleSVG from './img/schedule.svg';
import screenActivateSVG from './img/screen-activate.svg';
import screenCastingSVG from './img/screen-casting.svg';
import screenDeactivateSVG from './img/screen-deactivate.svg';
import screenMoveSVG from './img/screen-move.svg';
import screenSelectedSVG from './img/screen-selected.svg';
import screenSVG from './img/screen.svg';
import searchSVG from './img/search.svg';
import secureSiteSVG from './img/secure-site.svg';
import settingSVG from './img/settings.svg';
import shareSVG from './img/share.svg';
import sharedSVG from './img/shared.svg';
import shrinkSVG from './img/shrink.svg';
import skipNextSVG from './img/skip-next.svg';
import skipPreviousSVG from './img/skip-previous.svg';
import spacesSVG from './img/spaces.svg';
import splashRemoveSVG from './img/splash-remove.svg';
import splashSVG from './img/splash.svg';
import starSVG from './img/star.svg';
import stopSVG from './img/stop.svg';
import switchSVG from './img/switch.svg';
import tagSVg from './img/tag.svg';
import templateSVG from './img/template.svg';
import themeRemoveDefaultSVG from './img/theme-remove-default.svg';
import themesSVG from './img/themes.svg';
import trashSVG from './img/trash.svg';
import undoSVG from './img/undo.svg';
import unlockSVG from './img/unlock.svg';
import upgradeSVG from './img/upgrade.svg';
import videoSVG from './img/video.svg';
import viewSVG from './img/view.svg';
import warningSVG from './img/warning.svg';
import websiteSVG from './img/website.svg';
export var IconsList = {
    '4k': {
        src: fourKSVG,
        width: '20px',
        height: '14px',
    },
    'add-folder': {
        src: addFolderSVG,
        width: '20px',
        height: '20px',
    },
    'add-to-list': {
        src: addTodoListSVG,
        width: '20px',
        height: '20px',
    },
    'add-user': {
        src: addUserSVG,
        width: '18px',
        height: '18px',
    },
    'align-bottom': {
        src: alignBottomSVG,
        width: '20px',
        height: '20px',
    },
    'align-left': {
        src: alignLeftSVG,
        width: '20px',
        height: '20px',
    },
    'align-right': {
        src: alignRightSVG,
        width: '20px',
        height: '20px',
    },
    'align-top': {
        src: alignTopSVG,
        width: '20px',
        height: '20px',
    },
    'align-h-center': {
        src: alignHCenterSVG,
        width: '20px',
        height: '20px',
    },
    'align-v-center': {
        src: alignVCenterSVG,
        width: '20px',
        height: '20px',
    },
    'align-text-left': {
        src: alignTextLeftSVG,
        width: '20px',
        height: '20px',
    },
    'align-text-center': {
        src: alignTextCenterSVG,
        width: '20px',
        height: '20px',
    },
    'align-text-right': {
        src: alignTextRightSVG,
        width: '20px',
        height: '20px',
    },
    'app': {
        src: appSVG,
        width: '16px',
        height: '16px',
    },
    'app-store': {
        src: appStoreSVG,
        width: '20px',
        height: '20px',
    },
    'arrow-down': {
        src: arrowDownSVG,
        width: '16px',
        height: '16px',
    },
    'arrow-left': {
        src: arrowLeftSVG,
        width: '16px',
        height: '16px',
    },
    'arrow-right': {
        src: arrowRightSVG,
        width: '10px',
        height: '16px',
    },
    'arrow-up': {
        src: arrowUpSVG,
        width: '16px',
        height: '16px',
    },
    'audio': {
        src: audioSVG,
        width: '18px',
        height: '18px',
    },
    'audio-off': {
        src: audioOffSVG,
        width: '16px',
        height: '14px',
    },
    'audio-on': {
        src: audioOnSVG,
        width: '16px',
        height: '16px',
    },
    'basic-site': {
        src: basicSiteSVG,
        width: '20px',
        height: '20px',
    },
    'bulb': {
        src: bulbSVG,
        width: '20px',
        height: '20px',
    },
    'bulb-off': {
        src: bulbOffSVG,
        width: '20px',
        height: '20px',
    },
    'calendar': {
        src: calendarSVG,
        width: '16px',
        height: '16px',
    },
    'camera': {
        src: cameraSVG,
        width: '18px',
        height: '18px',
    },
    'canvas-brush': {
        src: canvasBrushSVG,
        width: '20px',
        height: '20px',
    },
    'caret-down': {
        src: caretDownSVG,
        width: '16px',
        height: '16px',
    },
    'caret-down-mini': {
        src: caretDownSVG,
        width: '10px',
        height: '10px',
    },
    'caret-up': {
        src: caretUpSVG,
        width: '16px',
        height: '16px',
    },
    'casting': {
        src: castingSVG,
        width: '20px',
        height: '20px',
    },
    'channel': {
        src: channelSVG,
        width: '18px',
        height: '18px',
    },
    'checkbox-empty': {
        src: checkboxEmptySVG,
        width: '16px',
        height: '16px',
    },
    'checkbox-deselect': {
        src: checkboxDeselectSVG,
        width: '16px',
        height: '16px',
    },
    'checkbox-checked': {
        src: checkboxCheckedSVG,
        width: '16px',
        height: '16px',
    },
    'checked-circle': {
        src: checkedCircleSVG,
        width: '16px',
        height: '16px',
    },
    'circle': {
        src: circleSVG,
        width: '16px',
        height: '16px',
    },
    'circle-arrow-left': {
        src: circleArrowLeftSVG,
        width: '16px',
        height: '16px',
    },
    'circle-arrow-right': {
        src: circleArrowRightSVG,
        width: '16px',
        height: '16px',
    },
    'clear-cache': {
        src: clearCacheSVG,
        width: '18px',
        height: '18px',
    },
    'clipboard': {
        src: clipboardSVG,
        width: '20px',
        height: '20px',
    },
    'clock': {
        src: clockSVG,
        width: '16px',
        height: '16px',
    },
    'close': {
        src: closeSVG,
        width: '14px',
        height: '14px',
    },
    'create-playlist': {
        src: createPlaylistSVG,
        width: '20px',
        height: '20px',
    },
    'dashboard': {
        src: dashboardSVG,
        width: '18px',
        height: '18px',
    },
    'disable-view': {
        src: disableViewSVG,
        width: '16px',
        height: '16px',
    },
    'document': {
        src: documentSVG,
        width: '18px',
        height: '18px',
    },
    'dot': {
        src: dotSVG,
        width: '16px',
        height: '16px',
    },
    'download': {
        src: downloadSVG,
        width: '16px',
        height: '16px',
    },
    'drag': {
        src: dragSVG,
        width: '16px',
        height: '16px',
    },
    'duplicate': {
        src: duplicateSVG,
        width: '20px',
        height: '20px',
    },
    'edit': {
        src: editSVG,
        width: '16px',
        height: '16px',
    },
    'edit-circle': {
        src: editCircleSVG,
        width: '16px',
        height: '16px',
    },
    'email-add': {
        src: emailAddSVG,
        width: '24px',
        height: '24px',
    },
    'email-cancel': {
        src: emailCancelSVG,
        width: '22px',
        height: '22px',
    },
    'email-resend': {
        src: emailResendSVG,
        width: '24px',
        height: '24px',
    },
    'email': {
        src: emailSVG,
        width: '20px',
        height: '20px',
    },
    'enter-fullscreen': {
        src: enterFullScreenSVG,
        width: '16px',
        height: '16px',
    },
    'exit-fullscreen': {
        src: exitFullScreenSVG,
        width: '16px',
        height: '16px',
    },
    'expand': {
        src: expandSVG,
        width: '18px',
        height: '18px',
    },
    'external': {
        src: eternalSVG,
        width: '16px',
        height: '16px',
    },
    'globe': {
        src: globeSVG,
        width: '16px',
        height: '16px',
    },
    'grid': {
        src: gridSVG,
        width: '17px',
        height: '17px',
    },
    'groups': {
        src: groupsSVG,
        width: '20px',
        height: '20px',
    },
    'groups-remove-default': {
        src: groupsRemoveDefaultSVG,
        width: '20px',
        height: '20px',
    },
    'help': {
        src: helpSVG,
        width: '16px',
        height: '16px',
    },
    'home': {
        src: homeSVG,
        width: '18px',
        height: '18px',
    },
    'image': {
        src: imageSVG,
        width: '18px',
        height: '13px',
    },
    'info': {
        src: infoSVG,
        width: '16px',
        height: '16px',
        cursor: 'help',
    },
    'layer-back': {
        src: layerBackSVG,
        width: '20px',
        height: '20px',
    },
    'layer-forward': {
        src: layerForwardSVG,
        width: '20px',
        height: '20px',
    },
    'layer-to-back': {
        src: layerToBackSVG,
        width: '20px',
        height: '20px',
    },
    'layer-to-front': {
        src: layerToFrontSVG,
        width: '20px',
        height: '20px',
    },
    'link': {
        src: linkSVG,
        width: '18px',
        height: '18px',
    },
    'list': {
        src: listSVG,
        width: '17px',
        height: '17px',
    },
    'location': {
        src: locationSVG,
        width: '14px',
        height: '18px',
    },
    'lock': {
        src: lockSVG,
        width: '20px',
        height: '20px',
    },
    'logout': {
        src: logoutSVG,
        width: '17px',
        height: '17px',
    },
    'magic': {
        src: magicSVG,
        width: '16px',
        height: '16px',
    },
    'media': {
        src: mediaSVG,
        width: '16px',
        height: '16px',
    },
    'media-folder': {
        src: mediaFolderSVG,
        width: '16px',
        height: '16px',
    },
    'media-folder-shared': {
        src: mediaFolderShareSVG,
        width: '16px',
        height: '16px',
    },
    'media-move': {
        src: mediaMoveSVG,
        width: '20px',
        height: '20px',
    },
    'media-select': {
        src: mediaSelectSVG,
        width: '18px',
        height: '15px',
    },
    'minus': {
        src: minusSVG,
        width: '16px',
        height: '16px',
    },
    'minus-fill': {
        src: minusFillSVG,
        width: '16px',
        height: '16px',
    },
    'move': {
        src: moveSVG,
        width: '12px',
        height: '12px',
    },
    'owner-add': {
        src: ownerAddSVG,
        width: '24px',
        height: '24px',
    },
    'owner-remove': {
        src: ownerRemoveSVG,
        width: '23px',
        height: '23px',
    },
    'owner-switch': {
        src: ownerswitchSVG,
        width: '23px',
        height: '23px',
    },
    'pause': {
        src: pauseSVG,
        width: '16px',
        height: '16px',
    },
    'play': {
        src: playSVG,
        width: '16px',
        height: '16px',
    },
    'play-fullscreen': {
        src: playFullScreenSVG,
        width: '18px',
        height: '14px',
    },
    'playing-screen': {
        src: playingScreenSVG,
        width: '18px',
        height: '18px',
    },
    'playlist': {
        src: playlistSVG,
        width: '16px',
        height: '16px',
    },
    'plus': {
        src: plusSVG,
        width: '16px',
        height: '16px',
    },
    'plus-fill': {
        src: plusfillSVG,
        width: '16px',
        height: '16px',
    },
    'preview': {
        src: previewSVG,
        width: '18px',
        height: '18px',
    },
    'redo': {
        src: redoSVG,
        width: '20px',
        height: '20px',
    },
    'refresh': {
        src: refreshSVG,
        width: '18px',
        height: '18px',
    },
    'rocket': {
        src: rocketSVG,
        width: '18px',
        height: '18px',
    },
    'remove-fill': {
        src: removeFillSVG,
        width: '17px',
        height: '17px',
    },
    'search': {
        src: searchSVG,
        width: '16px',
        height: '16px',
    },
    'secure-site': {
        src: secureSiteSVG,
        width: '20px',
        height: '20px',
    },
    'settings': {
        src: settingSVG,
        width: '17px',
        height: '17px',
    },
    'screen': {
        src: screenSVG,
        width: '18px',
        height: '18px',
    },
    'screen-activate': {
        src: screenActivateSVG,
        width: '20px',
        height: '20px',
    },
    'screen-casting': {
        src: screenCastingSVG,
        width: '18px',
        height: '18px',
    },
    'screen-deactivate': {
        src: screenDeactivateSVG,
        width: '19px',
        height: '19px',
    },
    'screen-move': {
        src: screenMoveSVG,
        width: '22px',
        height: '22px',
    },
    'screen-selected': {
        src: screenSelectedSVG,
        width: '19px',
        height: '19px',
    },
    'schedule': {
        src: scheduleSVG,
        width: '18px',
        height: '18px',
    },
    'shrink': {
        src: shrinkSVG,
        width: '18px',
        height: '18px',
    },
    'share': {
        src: shareSVG,
        width: '18px',
        height: '18px',
    },
    'shared': {
        src: sharedSVG,
        width: '18px',
        height: '18px',
    },
    'skip-next': {
        src: skipNextSVG,
        width: '16px',
        height: '16px',
    },
    'skip-previous': {
        src: skipPreviousSVG,
        width: '16px',
        height: '16px',
    },
    'spaces': {
        src: spacesSVG,
        width: '20px',
        height: '20px',
    },
    'splash': {
        src: splashSVG,
        width: '18px',
        height: '18px',
    },
    'splash-remove': {
        src: splashRemoveSVG,
        width: '21px',
        height: '21px',
    },
    'star': {
        src: starSVG,
        width: '16px',
        height: '16px',
    },
    'stop': {
        src: stopSVG,
        width: '16px',
        height: '16px',
    },
    'switch': {
        src: switchSVG,
        width: '16px',
        height: '16px',
    },
    'tag': {
        src: tagSVg,
        width: '16px',
        height: '16px',
    },
    'template': {
        src: templateSVG,
        width: '20px',
        height: '20px',
    },
    'theme-remove-default': {
        src: themeRemoveDefaultSVG,
        width: '18px',
        height: '18px',
    },
    'themes': {
        src: themesSVG,
        width: '20px',
        height: '20px',
    },
    'trash': {
        src: trashSVG,
        width: '16px',
        height: '16px',
    },
    'undo': {
        src: undoSVG,
        width: '20px',
        height: '20px',
    },
    'unlock': {
        src: unlockSVG,
        width: '20px',
        height: '20px',
    },
    'upgrade': {
        src: upgradeSVG,
        width: '20px',
        height: '20px',
    },
    'video': {
        src: videoSVG,
        width: '18px',
        height: '18px',
    },
    'view': {
        src: viewSVG,
        width: '18px',
        height: '18px',
    },
    'warning': {
        src: warningSVG,
        width: '16px',
        height: '16px',
    },
    'website': {
        src: websiteSVG,
        width: '20px',
        height: '20px',
    },
};
//# sourceMappingURL=list.js.map